import React, { Component } from "react";

import { records, makeAsRead } from "../../services/notification";
import AppContext from "../../contexts/AppContext";

export class HeaderNotifications extends Component {
    state = { items: [], unread: 0 };
    componentDidMount() {
        var countDown = 0;
        setInterval(() => {
            if (countDown % 30 === 0) {
                records(this.context.state.lastNotification).then(response => {
                    let temp = this.state.items;
                    temp.push(...response.data);

                    this.setState({
                        items: temp,
                        unread: response.meta.unread
                    });

                    if (
                        response.data.length === 1 &&
                        parseInt(
                            localStorage.getItem("lastNotification"),
                            10
                        ) !== response.data[0].id
                    ) {
                        this.context.state.showCodeMessage(
                            response.data[0].body,
                            "info"
                        );
                    } else if (
                        response.data.length >= 1 &&
                        parseInt(
                            localStorage.getItem("lastNotification"),
                            10
                        ) !== response.data[response.data.length - 1].id
                    ) {
                        // this.context.state.showCodeMessage(
                        //     "You get new notification",
                        //     "info"
                        // );
                    }

                    if (temp.length >= 1) {
                        this.context.state.upateNotification(
                            temp[temp.length - 1].id,
                            temp
                        );
                    }
                });
            }
            countDown = countDown + 1;
        }, 1000);
    }

    showNotification = () => {
        this.setState({
            unread: 0
        });
        makeAsRead(this.context.state.lastNotification);
        this.context.state.showNotification();
    };

    render() {
        return (
            <div className="position-relative d-inline-block dropdown">
                <a
                    className="link2 nav-link dropdown-toggler-notification"
                    id="dropdownNotification"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <span className="fe fe-bell notificationsCounts">
                        {this.state.unread === 0 ? null : (
                            <span className="badge badge-primary noteCount">
                                {this.state.unread}
                            </span>
                        )}
                    </span>
                </a>
                <div
                    className="dropdown-menu hide notifications dropdown-menu-right"
                    aria-labelledby="dropdownNotification"
                >
                    <div className="d-flex justify-content-between p-2">
                        <strong className="nav-link">Notifications</strong>
                        <a
                            className="nav-link view-all"
                            href="#sidebarModalActivity"
                            data-toggle="modal"
                            onClick={this.showNotification}
                        >
                            View All
                        </a>
                    </div>
                    <hr className="m-0" />
                    <div
                        id="NotificationContentDropDown"
                        className="list-group list-group-flush p-3"
                    >
                        {this.state.items.map((item, index) => {
                            return (
                                <div key={index} className="row no-gutters mb-1">
                                    <div className="col-12">
                                        <div className="small text-muted">
                                            <strong className="text-body">
                                                {item.body}
                                            </strong>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

HeaderNotifications.contextType = AppContext;
export default HeaderNotifications;



// WEBPACK FOOTER //
// ./src/components/notifications/HeaderNotifications.js